import { mapGetters } from 'vuex'
export default {
  name: 'payment-plan',
  data () {
    return {
      query: {},
      selected_mode: '',
      txnAmount: 0,
      operatorsLoaded: false,
      move: 400
    }
  },
  computed: {
    ...mapGetters(['loggedIn', 'planCategories', 'selectedCategory'])
  },
  methods: {
    selectCategory (category) {
      this.$store.dispatch('selectCategory', category)
    },
    navigateRight () {
      const view = document.querySelector('.nav__categories')
      const sliderLimit = view.scrollWidth
      const currentPosition = parseInt(view.scrollLeft)
      if (currentPosition <= sliderLimit) {
        view.scrollLeft += this.move < sliderLimit ? this.move : sliderLimit - currentPosition
      }
    },
    navigateLeft () {
      const view = document.querySelector('.nav__categories')
      const currentPosition = parseInt(view.scrollLeft)
      if (currentPosition > 0) {
        view.scrollLeft -= this.move < currentPosition ? this.move : currentPosition
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/PlanCategoryHeader/component.js